import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FcKindle, FcPlus, FcSportsMode } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const SubmenuGradesPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Sekolah",
    });
  }, [setHeader]);
  return (
    <div className="tw-p-4 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.HEALTH_PAGE)}
            className="tw-m-0"
          >
            <FcPlus className="card-icon" style={{ background: "#c4e9c4" }} />
            <div className="tw-mt-0 card-name">Kesehatan</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.ABSENCE_PAGE)}
            className="tw-m-0"
          >
            <FcKindle className="card-icon" style={{ background: "#eee" }} />
            <div className="tw-mt-0 card-name">Absensi</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.EKSKUL_ABSENCE_PAGE)}
            className="tw-m-0"
          >
            <FcSportsMode className="card-icon" style={{ background: "#e8f5e9" }} />
            <div className="tw-mt-0 card-name">Absensi Ekskul</div>
          </div>
        </div>
      </div>
    </div>
  );
};
